import BookingShorthand from "../../booking/flightAdmin/components/BookingShorthand"
import ProfileShorthand from "../../profile/components/ProfileShorthand";
import TaskShorthand from "../../project/task/components/TaskShortHand"
import BudgetSH from "../../account/budget/Components/BudgetSH";
import ProdShorthand from "../../project/production/order/components/ProdShorthand";
import ItemShorthand from '../../item/item/components/ItemShorthand';

import DocTableContainer from "../docTable/DocTableContainer";
import DocXYGridContainer from "../docXYGrid/DocXYGridContainer";
import DocCalGridContainer from "../docCalGrid/DocCalGridContainer";

import DesignOPSSearchBatchAction from "./components/actionComponents/DesignOPSSearchBatchAction";
import DesignOPSConsignmentSearchBatchAction from "./components/actionComponents/DesignOPSConsignmentSearchBatchAction";
import BudgetSearchBatchAction from "./components/actionComponents/BudgetSearchBatchAction";
import ProfileSearchBatchAction from "./components/actionComponents/ProfileSearchBatchAction";
import ReviewSearchBatchAction from "./components/actionComponents/ReviewSearchBatchAction";
import PRSearchBatchAction from "./components/actionComponents/PRSearchBatchAction";
import POSearchBatchAction from "./components/actionComponents/POSearchBatchAction";
import SOSearchBatchAction from "./components/actionComponents/SOSearchBatchAction";
import DesignSearchPriceINVAction from "./components/actionComponents/DesignSearchPriceINVAction";
import ItemPromo from '../../item/item/components/ItemPromo';

import cmnViewMap from '../Index';
import systemViewMap from '../../system/Index';

const searchViewMap = {
    "vBookingShorthand":BookingShorthand,
    "vProShorthand":ProfileShorthand,
    "vItemShorthand": ItemShorthand,
    "vTaskShorthand":TaskShorthand,
    "vBudgetSH":BudgetSH,
    "vProdSH":ProdShorthand,

    "vReviewSearchBatchAction":ReviewSearchBatchAction,
    "vDesignOPSSearchBatchAction":DesignOPSSearchBatchAction,
    "vDesignOPSConsignmentSearchBatchAction":DesignOPSConsignmentSearchBatchAction,
    "vPRSearchBatchAction":PRSearchBatchAction,
    "vPOSearchBatchAction":POSearchBatchAction,
    "vSOSearchBatchAction":SOSearchBatchAction,
    "vDesignSearchPriceINVAction":DesignSearchPriceINVAction,
    "vBudgetSearchBatchAction":BudgetSearchBatchAction,
    "vCMNSearchTableGrid" : DocTableContainer,
    "vCMNSearchXYGrid" : DocXYGridContainer,
    "vCMNSearchCalendarGrid" : DocCalGridContainer,
    "vProSearchBatchAction":ProfileSearchBatchAction,

    "vItemPromo": ItemPromo,

    ...cmnViewMap,
    ...systemViewMap
}

export default searchViewMap;
